<mat-toolbar class="bar-filler">
    <div></div>
</mat-toolbar>
<div *ngIf="orderData?.Balcony" matRipple class="no-outline pointer-cursor" (click)="setOrderType(1)">
    <div class="small-margin small-padding">
        <img src="/assets/img/balcony.png" onerror="this.src='/assets/img/placeholder.png'"style="height: 50px; margin: 5px;">
        <div class="label">{{'Pages.OrderType.Balcony.Title' | translate}}</div>
        <div class="detail">{{'Pages.OrderType.Balcony.Description' | translate}} {{orderData.BalconyWaitTime}}</div>
    </div>
    <mat-divider></mat-divider>
</div>
<div *ngIf="orderData?.Delivery" matRipple class="no-outline pointer-cursor"(click)="setOrderType(2)">
    <div class="small-margin small-padding">
        <img src="/assets/img/delivery.png" onerror="this.src='/assets/img/placeholder.png'" style="height: 50px; margin: 5px;">
        <div class="label">{{'Pages.OrderType.Delivery.Title' | translate}}</div>
        <div class="detail">{{'Pages.OrderType.Delivery.Description' | translate}} {{orderData.DeliveryWaitTime}}</div>
        <div *ngIf="orderData?.HasFloor === true" class="detail small-margin">{{'Pages.OrderType.Delivery.MinimumOrder' | translate}} {{orderData.FloorValueString}}</div>
        <div *ngIf="orderData?.HasFee === true" class="detail small-margin">{{orderData.FeeString}}</div>
        <div *ngIf="orderData?.HasFee === false" class="detail small-margin">{{'Pages.OrderType.Delivery.FeeString.NoTax' | translate}}</div>
    </div>
    <mat-divider></mat-divider>
</div>
<div *ngIf="orderData?.WillComeHere" matRipple class="no-outline pointer-cursor" (click)="setOrderType(3)">
    <div class="small-margin small-padding">
        <img src="/assets/img/table.png" onerror="this.src='/assets/img/placeholder.png'" style="height: 50px; margin: 5px;">
        <div class="label">{{'Pages.OrderType.WillComeHere.Title' | translate}}</div>
        <div class="detail">{{'Pages.OrderType.WillComeHere.Description' | translate}} {{orderData.WillComeHereWaitTime}}</div>
    </div>
    <mat-divider></mat-divider>
</div>
<div *ngIf="orderData?.Drive" matRipple class="no-outline pointer-cursor" (click)="setOrderType(4)"> 
    <div class="small-margin small-padding">
        <img src="/assets/img/drive.png" onerror="this.src='/assets/img/placeholder.png'" style="height: 50px; margin: 5px;">
        <div class="label">{{'Pages.OrderType.Drive.Title' | translate}}</div>
        <div class="detail">{{'Pages.OrderType.Drive.Description' | translate}} {{orderData.DriveWaitTime}}</div>
    </div>
    <mat-divider></mat-divider>
</div>
<mat-toolbar color="primary" class="top-bar">
    <button mat-icon-button (click)="back()">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <div>{{'Pages.OrderType.Title' | translate}}</div>
</mat-toolbar>